import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  CustomerDetailStatus,
} from "../../../types";
import { emptyCustomerDetails } from "../../../redux/initialState";
import {
  selectCustomerDetailStatusLabelKey,
  selectCustomerDetails,
  toCustomerDetailStatus,
} from "../../../redux/selector";
import { customersActions } from "../../../redux/slice";
import { useStyles } from "../CustomerDetailsForm/styles";

export const STATUS_OPTIONS = [
  CustomerDetailStatus.DRAFT,
  CustomerDetailStatus.ACTIVE,
  CustomerDetailStatus.INACTIVE,
];

export const useCustomerDetailsForm = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const customerDetails = useSelector(selectCustomerDetails);
  const formData = customerDetails || emptyCustomerDetails;

  const statusValue = toCustomerDetailStatus(formData.status);

  const statusLabel = (status: string) =>
    t(selectCustomerDetailStatusLabelKey(status));

  const getStatusBadgeClassName = (status: string) => {
    if (status === CustomerDetailStatus.ACTIVE) {
      return `${styles.statusBadge} ${styles.statusActive}`;
    }

    if (status === CustomerDetailStatus.INACTIVE) {
      return `${styles.statusBadge} ${styles.statusInactive}`;
    }

    return `${styles.statusBadge} ${styles.statusDraft}`;
  };

  const onStatusChange = (status: string) => {
    dispatch(customersActions.setCustomerDetailsStatus(status));
  };

  return {
    t,
    styles,
    formData,
    statusValue,
    statusLabel,
    getStatusBadgeClassName,
    onStatusChange,
    statusOptions: STATUS_OPTIONS,
    contacts: formData.contacts || [],
  };
};
